import { TemplateHelper, ConfigHelper, LocalizationHelper } from "../../helpers"
import { Activity, Enums } from "../../models/common"

import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../user-session"
import { SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListService } from "../system"

//#region Public Types

export const ISSUE_CONTEXT_MENU_SERVICE_NAME = 'issueContextMenuService'
export const ISSUE_CONTEXT_MENU_SERVICE_PROVIDER_NAME = 'issueContextMenuServiceProvider'

export type IdIssueGridContextMenuOptions = {
    idReferenceTypes?: number[]
    onEdit?: (args: any) => void
}

//#endregion

export class IssueContextMenuService {

    // #region Ctor

    public constructor(
        private readonly systemContextListService: SystemContextListService,
        private readonly userSessionService: UserSessionService
    ) { }

    // #endregion


    // #region Public Methods

    public getContextMenuItems(options: IdIssueGridContextMenuOptions): any[] {
        const items: { beginGroup?: boolean, template: string, onItemClick: (args: any) => void }[] = []

        if (options == null) {
            return items
        }

        if (options.onEdit != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.ISSUE_EDIT)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit), ConfigHelper.Icon.EDIT, this.userSessionService),

                onItemClick: (e: any) => {
                    options.onEdit(e)
                }
            })
        }

        if (options.idReferenceTypes != null) {

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationModule)
            ) {
                items.push({
                    beginGroup: true,
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowLocations), ConfigHelper.Icon.LOCATIONS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdLocation, options.idReferenceTypes, Enums.ReferenceType.IdIssue)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowMeters), ConfigHelper.Icon.METERS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdMeter, options.idReferenceTypes, Enums.ReferenceType.IdIssue)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DeviceModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowDevices), ConfigHelper.Icon.DEVICES, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.SerialNbr, options.idReferenceTypes, Enums.ReferenceType.IdIssue)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowTasks), ConfigHelper.Icon.TASKS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdTask, options.idReferenceTypes, Enums.ReferenceType.IdIssue)
                    }
                })
            }
        }

        return items
    }

    // #endregion
}

export class IssueContextMenuServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [SYSTEM_CONTEXT_LIST_SERVICE_NAME, USER_SESSION_SERVICE_NAME, function (systemContextListService: SystemContextListService, userSessionService: UserSessionService) {
        return new IssueContextMenuService(systemContextListService, userSessionService)
    }]

    //#endregion
} 
